import { createSelector, createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoading: false,
  isActive: false,
  id: 0,
  uid: 0,
  sid: 0,
  blockContent: {
    items: [],
    heading: {
      title: '',
      description: '',
      textAlign: 'left',
      image: '',
      divider: '',
      position: '',
    },
  },
  blockDesign: {
    view: 'feed',
    layout: '1',
  },
  itemDesign: {},
  containerDesign: {},
};

export const teamSlice = createSlice({
  name: 'team',
  initialState,
  reducers: {
    teamStore: (state, action) => {
      const { id, isActive, sid, uid, data } = action.payload;
      const block = data ?? {};
      const { blockContent, blockDesign } = block;
      const { itemDesign, containerDesign } = blockDesign;

      state.isLoading = false;
      state.id = id ?? 0;
      state.isActive = isActive;
      state.sid = sid;
      state.uid = uid;

      state.itemDesign = itemDesign ?? {};
      state.containerDesign = containerDesign ?? {};

      state.blockContent = {
        items: blockContent.items ?? [],
        heading: {
          title: blockContent.heading?.title ?? '',
          description: blockContent.heading?.description ?? '',
          textAlign: blockContent.heading?.textAlign ?? 'left',
          image: blockContent.heading?.image ?? '',
          divider: blockContent.heading?.divider ?? '',
          position: blockContent.heading?.position ?? '',
        },
      };

      state.blockDesign = {
        view: blockDesign.view ?? 'feed',
        layout: blockDesign.layout ?? '1',
      };
    },
    teamClear: () => initialState,
    teamUpdateIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    teamUpdateIsActive: (state, action) => {
      state.isActive = action.payload;
    },
    teamUpdateBlockContent: (state, action) => {
      state.blockContent = action.payload;
    },
    teamUpdateBlockDesign: (state, action) => {
      state.blockDesign = action.payload;
    },
  },
});

export const { teamStore, teamClear, teamUpdateIsLoading, teamUpdateIsActive, teamUpdateBlockContent, teamUpdateBlockDesign } = teamSlice.actions;

export const selectTeamIsLoading = (state) => state.team.isLoading;
export const selectTeamId = (state) => state.team.id;
export const selectTeamUID = (state) => state.team.uid;
export const selectTeamSID = (state) => state.team.sid;
export const selectTeamBlockContent = (state) => state.team.blockContent;
export const selectTeamBlockDesign = (state) => state.team.blockDesign;
export const selectTeamSortItems = createSelector([selectTeamBlockContent], ({ items }) => items ?? []);
export const selectTeamItemDesign = (state) => state.team.itemDesign;
export const selectTeamContainerDesign = (state) => state.team.containerDesign;

export default teamSlice.reducer;
